<app-welcome></app-welcome>
<app-map></app-map>
<app-arrived-now></app-arrived-now>
<app-discover></app-discover>
<app-follow></app-follow>
<app-category-news></app-category-news>
<app-depositions></app-depositions>
<app-donors></app-donors>